import React from 'react';
import IRichText from '../../../models/viewModels/base/IRichText';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import LinkButton from '../../atoms/link-button/link-button';
import styles from './rich-text.module.scss';

export type RichTexProps = {
  richText: IRichText;
};

export default function RichText({ richText }: RichTexProps) {
  const entryBlockMap = new Map();

  if (richText?.links?.entries?.inline) {
    richText?.links?.entries?.inline.forEach((entry) => {
      entryBlockMap.set(entry?.sys?.id, entry);
    });
  }
  richText?.json?.content.forEach((item) => {
    if (item.nodeType === BLOCKS.TABLE) {
      if (item.content[0].content.find((node) => node.nodeType === BLOCKS.TABLE_HEADER_CELL)) {
        item.content.forEach((row) => {
          row.content.forEach((cell) => {
            if (cell.nodeType === BLOCKS.TABLE_CELL) {
              cell.hasTableHeaders = true; // adds check if Table has header col
            }
          });
        });

        for (let i = 0; i < item.content[0].content.length; i += 1) {
          item.content.forEach((row) => {
            if (row.content[i].hasTableHeaders) {
              // adds table header col content as param to table cell for responsive view
              row.content[i].labelForMobile =
                item.content[0]?.content[i]?.content[0]?.content[0]?.value;
            }
          });
        }
      }
    }
  });

  const options = {
    renderNode: {
      [BLOCKS.TABLE_CELL]: (node, children) => {
        if (node.hasTableHeaders) {
          return (
            // returns table cell with data attr for responsive view
            <td data-title={node.labelForMobile}>{children}</td>
          );
        }

        // returns default table cell
        return <td>{children}</td>;
      },

      [BLOCKS.TABLE]: (node, children) => {
        return (
          <div className={styles[`rich-text-table-block`]}>
            <table className={styles[`rich-text-table`]}>
              <tbody>{children}</tbody>
            </table>
          </div>
        );
      },

      // eslint-disable-next-line react/prop-types
      [INLINES.EMBEDDED_ENTRY]: ({ data }) => {
        // eslint-disable-next-line react/prop-types
        const entry = entryBlockMap.get(data?.target?.sys?.id);

        // eslint-disable-next-line no-underscore-dangle
        if (entry.__typename === `ComponentCta`) {
          return <LinkButton link={entry?.urlLink} text={entry?.ctaText} />;
        }

        return null;
      },
    },
  };

  return (
    <div className={`${styles[`rich-text-block`]} rt-block`}>
      {documentToReactComponents(richText?.json, options)}
    </div>
  );
}
